import { Check } from "lucide-react";
import { usePasswordValidation } from "../../hooks/usePasswordValidation";
import { useTranslation } from "../../context/TranslationContext";

interface PasswordCriteriaProps {
  password: string;
  className?: string;
}

export function PasswordCriteria({ password, className = "" }: PasswordCriteriaProps) {
  const { t } = useTranslation();
  const validation = usePasswordValidation(password);

  const criteria = [
    { key: 'minLength', label: t('auth.passwordMinLength'), isValid: validation.minLength },
    { key: 'uppercase', label: t('auth.passwordUppercase'), isValid: validation.hasUppercase },
    { key: 'number', label: t('auth.passwordNumber'), isValid: validation.hasNumber },
    { key: 'specialChar', label: t('auth.passwordSpecialChar'), isValid: validation.hasSpecialChar },
  ];

  return (
    <div data-tsx-id="password-criteria" className={`flex flex-wrap gap-3 mt-2 ${className}`}>
      {criteria.map((criterion) => (
        <div key={criterion.key} className="flex items-center gap-1">
          <Check 
            className={`w-3.5 h-3.5 ${criterion.isValid ? 'text-green-600' : 'text-zinc-300'}`}
          />
          <span className={`text-xs ${criterion.isValid ? 'text-green-600' : 'text-zinc-500'}`}>
            {criterion.label}
          </span>
        </div>
      ))}
    </div>
  );
}
